"use strict";
// TODO RX-TUBES add all needed !!
Object.defineProperty(exports, "__esModule", { value: true });
exports.rxRohrPatches = exports.rxRohrIaPatches = void 0;
/**
 * Additional data required to use rx-rohr innenaufteilung in echain context.
 *
 * todo move to ipro
 */
exports.rxRohrIaPatches = [
    {
        artNr: 'RX32.1.1',
        IAHKH_mm: 41.5,
        iaHKULUH_mm: 2,
        iaHKOLOH_mm: 2,
    },
    {
        artNr: 'RX32.2.1',
        IAHKH_mm: 37,
        iaHKULUH_mm: 2,
        iaHKOLOH_mm: 2,
    },
    {
        artNr: 'RX40.1.1',
        IAHKH_mm: 51.5,
        iaHKULUH_mm: 2,
        iaHKOLOH_mm: 2,
    },
    {
        artNr: 'RX40.2.1',
        IAHKH_mm: 47,
        iaHKULUH_mm: 2,
        iaHKOLOH_mm: 2,
    },
    {
        artNr: 'RX48.1.1',
        IAHKH_mm: 61.5,
        iaHKULUH_mm: 2,
        iaHKOLOH_mm: 2,
    },
    {
        artNr: 'RX48.2.1',
        IAHKH_mm: 57,
        iaHKULUH_mm: 2,
        iaHKOLOH_mm: 2,
    },
    {
        artNr: 'RX56.1.1',
        IAHKH_mm: 69,
        iaHKULUH_mm: 2,
        iaHKOLOH_mm: 2,
    },
    {
        artNr: 'RX56.2.1',
        IAHKH_mm: 63.5,
        iaHKULUH_mm: 2,
        iaHKOLOH_mm: 2,
    },
];
/**
 * Additional data required to use rx-rohr in echain context.
 *
 * todo move to ipro
 *
 * TODO RX-TUBES check data and if its still needed to add the width of the IA elements?
 */
exports.rxRohrPatches = [
    {
        serieRef: 'RX32',
        minDist: 5,
        rastPos: 17 + 3,
        artSerieBreite: 'RX32.080',
    },
    {
        serieRef: 'RX40',
        minDist: 5,
        rastPos: 22 + 3,
    },
    {
        serieRef: 'RX48',
        minDist: 5,
        rastPos: 27 + 3,
    },
    {
        serieRef: 'RX56',
        minDist: 5,
        rastPos: 32 + 3,
    },
];
//# sourceMappingURL=RxRohrPatches.js.map